export default __webpack_public_path__ + "static/media/sky.94e5c985.webp";